/**
 * SearchInput Component
 * Search input with icon.
 */

import { forwardRef, type InputHTMLAttributes } from 'react';
import styles from './SearchInput.module.css';

/**
 * SearchInput component props.
 */
interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Full width input */
  fullWidth?: boolean;
}

/**
 * Search icon SVG component.
 */
const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8.25 14.25a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM15.75 15.75l-3.262-3.262"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Search input component with search icon.
 */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ fullWidth = false, className = '', placeholder = 'Search...', ...props }, ref) => {
    const containerClasses = [styles.container, fullWidth ? styles.fullWidth : '', className]
      .filter(Boolean)
      .join(' ');

    return (
      <div className={containerClasses}>
        <span className={styles.icon}>
          <SearchIcon />
        </span>
        <input
          ref={ref}
          type="search"
          className={styles.input}
          placeholder={placeholder}
          {...props}
        />
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';

